/* Wärmlinge – Warenkorb-Logik (Kaufbox per Ajax, Zusatzfarbe, Lieferdatum) */
(function () {
  'use strict';

  var MONTHS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function fmt(d) {
    return d.getDate() + '. ' + MONTHS[d.getMonth()];
  }

  if (!customElements.get('wm-eta')) {
    customElements.define('wm-eta', class extends HTMLElement {
      connectedCallback() {
        var min = parseInt(this.dataset.min || '10', 10);
        var max = parseInt(this.dataset.max || '11', 10);
        var now = new Date();
        var a = addBusinessDays(now, min);
        var b = addBusinessDays(now, max);
        var same = a.getMonth() === b.getMonth();
        this.textContent = 'Ankunft ca. ' + (same ? a.getDate() + '.' : fmt(a)) + '–' + fmt(b);
      }
    });
  }

  function addToCart(variantId, quantity) {
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      return actions.updateCart(
        { lines: [{ merchandiseId: String(variantId), quantity: quantity }] },
        { event: { context: 'product' } }
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        if (actions.openCart) actions.openCart();
        return res;
      });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/cart';
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-wm-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var id = form.querySelector('[name="id"]').value;
    var qty = parseInt(form.querySelector('[name="quantity"]').value, 10) || 1;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    addToCart(id, qty)
      .catch(function () { HTMLFormElement.prototype.submit.call(form); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wm-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '…';
    addToCart(btn.getAttribute('data-wm-add'), 1).catch(function () {
      btn.disabled = false;
      btn.textContent = '+ Dazu';
    });
  });
})();
